const findScrollableParent = (el) => {
	if (!el) {
		return null;
	} else if (el.scrollHeight > el.clientHeight) {
		return el;
	} else {
		return findScrollableParent(el.parentElement);
	}
};

const calcOffsetFromParent = (el, parent) => {
	if (!el || !parent) {
		return 0;
	} else if (el === parent) {
		return 0;
	} else {
		return calcOffsetFromParent(el.parentElement, parent) + el.offsetTop;
	}
};

const bulletRenderer = (imageSrcs) => (index, className) => {
	return (
		'<div class="' +
		className +
		' w-16 h-16 rounded-2xl overflow-hidden">' +
		'<img class="w-full h-full object-center object-cover border-0" alt="" src="' +
		(imageSrcs[index].thumb || imageSrcs[index].href || imageSrcs[index]) +
		'" />' +
		'</div>'
	);
};

const unpackFunction = ({ f }) => f;

const id = (x) => x;
const getItem = (n) => (x) => x.data.items[n];

const reduceObject = (f, init, obj) => Object.entries(obj).reduce(f, init);

const mapObject = (f, obj) => Object.fromEntries(Object.entries(obj).map(f));
const mapObjectV = (f, obj) => mapObject(([k, v]) => [k, f(v)], obj);

const callObject = (validationFns) =>
	mapObject(([key, fn]) => [key, fn()], validationFns);

const unpackObject = (obj) =>
	mapObject(([key, { input }]) => [key, input], obj);

const isWholeObjectValid = (obj) =>
	reduceObject((a, [_, v]) => v.valid && a, true, obj);

const validPass = (input) => ({
	valid: true,
	errorMessage: '',
	input: input,
});

const validName = (input) => {
	const trimmed = input.trim();
	const isValid = /^[a-záéíóöőúüű\-\.]+[a-záéíóöőúüű\- ]*$/i.test(trimmed);
	return {
		valid: isValid,
		errorMessage: isValid
			? ''
			: trimmed === ''
				? 'A név ne legyen üres.'
				: 'A névben csak szóköz és betűk lehetnek.',
		input: isValid ? trimmed : '',
	};
};

const validCompanyName = (input) => {
	const trimmed = input.trim();
	const isValid = /^.{3,}$/i.test(
		trimmed
	);
	return {
		valid: isValid,
		errorMessage: isValid
			? ''
			: trimmed === ''
				? 'A név ne legyen üres.'
				: 'A névnek legalább 3 karakter hosszúnak kell lennie.',
		input: isValid ? trimmed : '',
	};
};

const validEmail = (input) => {
	const isValid =
		/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(
			input
		);
	return {
		valid: isValid,
		errorMessage: isValid ? '' : 'Helytelen email cím.',
		input: isValid ? input : '',
	};
};

const validPassword = (input) => {
	const isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(
		input
	);
	return {
		valid: isValid,
		errorMessage: isValid
			? ''
			: 'Nem megfelelő jelszó!',
		input: isValid ? input : '',
	};
};

const validTaxCode = (input) => {
	const isValid =
		/\d{8}\-?[1-5]{1}\-?(02|22|03|23|04|24|05|25|06|26|07|27|08|28|09|29|10|30|11|31|12|32|13|33|14|34|15|35|16|36|17|37|18|38|19|39|20|40|41|42|43|44|51)/.test(
			input
		);
	return {
		valid: isValid,
		errorMessage: isValid ? '' : 'Hibás formátumú az adóazonosító.',
		input: isValid ? input : '',
	};
};

const validPhone = (input) => {
	const isValid = true; ///[+]?\d{3, 12}/.test(input)
	return {
		valid: isValid,
		errorMessage: isValid ? '' : 'Hibás formátumú telefonszám.',
		input: isValid ? input : '',
	};
};

const combineValidation = (f1, f2) => {
	return (input) => {
		const value1 = f1(input);
		const value2 = f2(input);
		return {
			valid: value1.valid && value2.valid,
			errorMessage: value1.errorMessage || value2.errorMessage || '',
			input: value1.input || value2.input || '',
		};
	};
};

export {
	findScrollableParent,
	calcOffsetFromParent,
	bulletRenderer,
	id,
	getItem,
	mapObject,
	mapObjectV,
	callObject,
	unpackObject,
	unpackFunction,
	validPass,
	validName,
	validCompanyName,
	validEmail,
	validPassword,
	validTaxCode,
	validPhone,
	combineValidation,
	reduceObject,
	isWholeObjectValid,
};
